import * as i0 from '@angular/core';
import { Component, Input } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { UserImageComponent } from '@arematics/core/user-image';
import * as i1 from '@arematics/core/api';

class OwnerComponent {
    nameService;
    ref;
    _uuid;
    size = 'normal';
    loggedInUser = false;
    get uuid() {
        return this._uuid;
    }
    set uuid(uuid) {
        this._uuid = uuid;
        this.fetchNameOrOrgaTitle();
    }
    loadedName;
    user;
    constructor(nameService, ref) {
        this.nameService = nameService;
        this.ref = ref;
    }
    ngOnInit() {
        this.fetchNameOrOrgaTitle();
    }
    handleNameLoadSuccess(name) {
        this.loadedName = name;
        this.user = {
            uid: this.uuid,
            label: name[0],
        };
        this.ref.markForCheck();
    }
    fetchNameOrOrgaTitle() {
        if (!this._uuid || this._uuid === 'Anonym') {
            this.handleNameLoadSuccess('Anonym');
        }
        else {
            this.nameService.fetchName(this._uuid)
                .subscribe((name) => this.handleNameLoadSuccess(name));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OwnerComponent, deps: [{ token: i1.NameService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: OwnerComponent, isStandalone: true, selector: "a-owner[uuid]", inputs: { size: "size", loggedInUser: "loggedInUser", uuid: "uuid" }, ngImport: i0, template: `
		<div class="flex flex-row align-items-center" *ngIf="loadedName">
			<a-user-image [user]="user" [size]="size" [loggedInUser]="loggedInUser"></a-user-image>
			<div class="ml-2" [ngClass]="{'text-xl': size === 'large', 'text-3xl font-bold': size === 'xlarge'}">{{ loadedName | titlecase }}</div>
		</div>
	`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.TitleCasePipe, name: "titlecase" }, { kind: "ngmodule", type: AvatarModule }, { kind: "component", type: UserImageComponent, selector: "a-user-image", inputs: ["loggedInUser", "user", "fallback", "secure", "size", "innerClass", "editable"], outputs: ["changeAvatar"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OwnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-owner[uuid]', standalone: true, imports: [CommonModule, AvatarModule, UserImageComponent], template: `
		<div class="flex flex-row align-items-center" *ngIf="loadedName">
			<a-user-image [user]="user" [size]="size" [loggedInUser]="loggedInUser"></a-user-image>
			<div class="ml-2" [ngClass]="{'text-xl': size === 'large', 'text-3xl font-bold': size === 'xlarge'}">{{ loadedName | titlecase }}</div>
		</div>
	` }]
        }], ctorParameters: function () { return [{ type: i1.NameService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { size: [{
                type: Input
            }], loggedInUser: [{
                type: Input
            }], uuid: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { OwnerComponent };
